import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import './globals.css';
import { TITLE_PREFIX } from './lib/routing/documentTitle';

// Login/bootstrap renders before the authenticated shell owns the route title.
document.title = TITLE_PREFIX;

const root = ReactDOM.createRoot(document.getElementById('root')!);
const tree = (
  <React.StrictMode>
    <ErrorBoundary>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// #1150 — dev-only Novig fixture seam: `VITE_NOVIG_FIXTURES=1` in .env.local
// wraps the app in a gitignored local provider (src/lib/dev). The glob matches
// nothing on a clone without that file, and production never takes this branch.
if (import.meta.env.DEV && import.meta.env.VITE_NOVIG_FIXTURES === '1') {
  const [load] = Object.values(import.meta.glob<{ wrapNovigFixtures(app: React.ReactNode): React.ReactNode }>(
    './lib/dev/novigFixtures.local.ts'));
  void (load ? load().then((m) => m.wrapNovigFixtures(tree)) : Promise.resolve(tree)).then((app) => root.render(app));
} else {
  root.render(tree);
}
